import { StoreProduct } from '@medusajs/types'
import Link from 'next/link'
import { Dispatch, Ref, SetStateAction } from 'react'
import { getProductUrl } from '@onclicks/sharedmedusa/utils/get-product-url'

type Props = {
  inputRef: Ref<HTMLInputElement>
  query: string
  setQuery: Dispatch<SetStateAction<string>>
  isLoading: boolean
  results: StoreProduct[]
  handleClose: () => void
}

export default function SearchInput(props: Props) {
  const { inputRef, query, setQuery, isLoading, results, handleClose } = props

  return (
    <div className="absolute right-0 mt-2 w-80 max-w-[90vw] rounded-2xl bg-white shadow-xl border border-white/40 p-3 z-1001">
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Rechercher un produit..."
        className="w-full rounded-full border border-primary/20 px-4 py-2 text-sm focus:outline-none focus:border-primary"
      />

      {query.trim() && (
        <ul className="mt-2 max-h-80 overflow-y-auto divide-y divide-primary/10">
          {isLoading && <li className="py-3 text-sm text-center text-gray-500">Recherche...</li>}

          {!isLoading && results.length === 0 && (
            <li className="py-3 text-sm text-center text-gray-500">Aucun produit trouvé</li>
          )}

          {!isLoading &&
            results.map((product) => (
              <li key={product.id}>
                <Link
                  href={getProductUrl(product)}
                  onClick={handleClose}
                  className="flex items-center gap-3 py-2 px-1 rounded-lg hover:bg-primary/5"
                >
                  {product.thumbnail && (
                    <img
                      src={product.thumbnail}
                      alt={product.title}
                      className="w-10 h-10 rounded-lg object-cover shrink-0"
                    />
                  )}
                  <span className="text-sm font-medium truncate">{product.title}</span>
                </Link>
              </li>
            ))}
        </ul>
      )}
    </div>
  )
}
